import PropTypes from 'prop-types';
import React from 'react';
import { Button, Box } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './DealerCard.style';
import { pushGtmDealerCardInfo, SCHEDULE_SERVICE, PREFIX_TYPE } from '../../utils/gtmTags';

const ScheduleServiceButton = themeStyles.apply(Button, 'ScheduleServiceButton');
const ScheduleServiceButtonWrapper = themeStyles.apply(Box, 'ScheduleServiceButtonWrapper');

const DealerScheduleServiceButton = ({ serviceUrl, dealerCode, dealerName, handleClick }) => {
  const { t } = useTranslation();

  const handlePushGtmDealerInfo = () => {
    pushGtmDealerCardInfo(PREFIX_TYPE + SCHEDULE_SERVICE, dealerName, dealerCode);
    handleClick();
  };

  return (
    <ScheduleServiceButtonWrapper>
      <ScheduleServiceButton
        data-testid="cy-schedule-service-button"
        styling="secondary"
        as="a"
        href={serviceUrl}
        target="_blank"
        onClick={handlePushGtmDealerInfo}
      >
        {t('Sub-apps.Dealers.scheduleServiceButton')}
      </ScheduleServiceButton>
    </ScheduleServiceButtonWrapper>
  );
};

DealerScheduleServiceButton.propTypes = {
  serviceUrl: PropTypes.string,
  dealerName: PropTypes.string,
  dealerCode: PropTypes.string,
  handleClick: PropTypes.func,
};

export default DealerScheduleServiceButton;
